import CloudImg from "public/openStack/cloud.png";
import LightImg from "public/openStack/light.png";
import CubesImg from "public/openStack/cubes.png";
import VerifyImg from "public/openStack/tdesign_secured-filled.png";
import SecImg from "public/openStack/lock.png";

export const INCLUSION_CONSTANTS = [
  {
    image: CloudImg,
    title: "VM replication tools",
    text: "(Like Veeam, Zerto, or built-in OpenStack migrators)",
  },
  {
    image: LightImg,
    title: "Custom scripts",
    text: "for data mapping and transformation.",
  },
  {
    image: CubesImg,
    title: "Integrated identity and access mapping",
    text: "(AD, LDAP, etc.).",
  },
  {
    image: SecImg,
    title: "Application layer hooks",
    text: "for post-migration reconfiguration.",
  },
  {
    image: VerifyImg,
    title: "Service Mesh compatibility",
    text: "for microservices migrations.",
  },
];
